export default __webpack_public_path__ + "static/media/solutionset_needs_review.12e24e19.svg";